module.exports = __webpack_public_path__ + "static/staticContentYes-7b4d77fec04b747e70a8cc5297e93d38.png";